export default "__VITE_ASSET__8iWOejYP__"